import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-16 px-4" data-id="element-1990">
      <div className="max-w-4xl mx-auto text-center space-y-4" data-id="element-1991">
        <h1 className="text-4xl md:text-5xl font-bold text-white tracking-tight" data-id="element-1992">
          Sinker EDM
        </h1>
        <p className="text-xl text-white font-medium" data-id="element-1993">
          CNC Die Sinking Solutions
        </p>
      </div>
    </div>;
}